import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { RolService } from '@pages/rol/services/rol.service';
import { MicrosoftAuthService } from '@pages/authentication/services/microsoft-auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() isExpanded = false;
  @ViewChild('userMenu') userMenu!: Menu;
  
  usser: string = '';
  rolDescripcion: string = '';
  rolId: string = '';
  items: MenuItem[] = [];

  constructor(
    private router: Router,
    private _rolService: RolService,
    private microsoftAuthService: MicrosoftAuthService
  ) { }

  ngOnInit() {
    this.usser = JSON.parse(sessionStorage.getItem('nameUsser') || '""');
    this.loadRolDescripcion();
    this.initializeMenu();
  }

  initializeMenu() {
    this.items = [
      {
        label: 'Cambiar Contraseña',
        icon: 'pi pi-key',
        command: () => this.changepassword()
      },
      {
        label: 'Cerrar Sesión',
        icon: 'pi pi-sign-out',
        command: () => this.logout()
      }
    ];
  }

  toggleUserMenu(event: Event) {
    this.userMenu.toggle(event);
  }

  logout() {
    const isMicrosoft = this.microsoftAuthService.logout();
    // Si no es usuario de Microsoft, el logout ya limpió todo, solo navegar
    if (!isMicrosoft) {
      this.router.navigate(['sign-in']);
    }
    // Si es usuario de Microsoft, el logout redirige automáticamente al backend
  }

  changepassword() {
    this.router.navigate(['change-password']);
  }

  navigateToMail() {
    this.router.navigate(['centro-mensajes']);
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  loadRolDescripcion(): void {
    const rolId = sessionStorage.getItem('p9sh2');    
    if (rolId) {
      this.rolId = rolId;
      this._rolService.read().subscribe({
        next: (res) => {
          if (res.data && res.data.length > 0) {
            const rol = res.data.find((r: any) => r.id === parseInt(rolId));
            if (rol) {
              this.rolDescripcion = rol.description;
            } else {
              console.log('No se encontró el rol con ID:', rolId);
            }
          }
        },
        error: (error) => {
          console.error('Error al cargar roles:', error);
        }
      });
    }
  }
}
